import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'icon-container',
  templateUrl: './icon-container.component.html',
  styleUrl: './icon-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class IconContainerComponent {

}
